<template>
    <div id="assignment">
        <div class="right">
            <div class="header">
                <h4>To Do List</h4>
                <div class="list-btn">
                    <div class="btn-wraper">
                        <div @click="changeButtonFilter(BUTTONS_FILTER.ALL)"
                            :class="{ 'btn': true, 'active': activeButtonIndex == BUTTONS_FILTER.ALL }">
                            ALL</div>
                    </div>
                    <div class="btn-wraper">
                        <div @click="changeButtonFilter(BUTTONS_FILTER.ASSIGNMENT)"
                            :class="{ 'btn': true, 'active': activeButtonIndex == BUTTONS_FILTER.ASSIGNMENT }">
                            Assignment
                        </div>
                    </div>
                    <div class="btn-wraper">
                        <div @click="changeButtonFilter(BUTTONS_FILTER.TEST)"
                            :class="{ 'btn': true, 'active': activeButtonIndex == BUTTONS_FILTER.TEST }">Test</div>
                    </div>
                </div>

                <div class="search">
                    <div class="form">
                        <img class="icon-search" src="/themes/web/assets/images/icon/icon-search.svg" alt="">
                        <input v-model="keySearch" @input="searchAssignments" class="form-search" type="text" name=""
                            :placeholder="$t('Search an activity name')" id="q" />
                    </div>
                </div>
            </div>
            <div class="block-filter">
                <div class="course-title">Your courses</div>
                <div class="course-programs">
                    <div v-if="courses && courses.length > 0"
                        :class="course_id_filter == 0 ? 'program-card active' : 'program-card'" @click="clearFilter()"
                        ref="program_all">All Course</div>
                    <div v-if="courses && courses.length > 0" v-for="course in courses" v-bind:key="course.class_id"
                        :ref="'course_' + course.class_id"
                        :class="course_id_filter == course.course_id && class_id_filter == course.class_id ? 'program-card active' : 'program-card'"
                        @click="changeCourse(course)">
                        <p>{{ course.course_name }}</p>
                    </div>
                </div>
            </div>

            <div class="content">
                <div v-if="listAll.length == 0" class="no-data">
                    <p v-if="keySearch == ''">
                        No assignments or tests right now! Time to relax and have fun!
                    </p>
                    <p v-else>
                        No results found. Maybe try checking your spelling or trying a different search term?
                    </p>
                </div>
                <div v-else class="list-asm">
                    <div :class="{
                        'item-asm overdue': item.is_ended,
                        'item-asm': !item.is_ended,
                        'item-asm lock': item.lock == 1
                    }" v-for="(item, index) in listAll" :key="index">
                        <div style="display: flex; align-items: center;width: 80%;">
                            <img v-if="iconMap[item.status]" :src="iconMap[item.status]" alt="">

                            <div style="margin-left: 10px;width: 100%;">
                                <div class="info">
                                    <p v-if="item.type_code == TYPE_CONTENT.ASM" class="type-asm">Assignment</p>
                                    <p v-else class="type-test">Test</p>
                                    <div class="dot-1"></div>
                                    <p class="course-title">{{ item.course_name }}</p>
                                    <div v-if="item.type_code == TYPE_CONTENT.ASM || item.type_code == TYPE_CONTENT.TEST_LESSON || item.type_code == TYPE_CONTENT.TEST_MODULE"
                                        class="dot-1"></div>
                                    <p class="path">{{ item.path }}</p>
                                </div>

                                <h4 class="title" v-if="item.type_code == TYPE_CONTENT.ASM">{{ item.name_asm }}</h4>
                                <h4 class="title" v-else-if="item.type_code == TYPE_CONTENT.TEST_LESSON">{{
                                    item.name_test_lesson }}</h4>
                                <h4 class="title" v-else-if="item.type_code == TYPE_CONTENT.TEST_MODULE">{{
                                    item.name_test_module }}</h4>
                                <h4 class="title" v-else-if="item.type_code == TYPE_CONTENT.TEST_SEMESTER">{{
                                    item.name_test_semester }}</h4>
                                <div :class="item.is_ended ? 'date overdue' : 'date'">
                                    Due Date: {{ (new Date()).customDate1(item.end_time,
                                        user_info.timezone) }}
                                </div>
                            </div>
                        </div>
                        <div v-if="statusConfig(item)" style="display: flex; align-items: center;">
                            <p :class="['p-status', statusConfig(item).class]">
                                {{ statusConfig(item).text }}
                            </p>
                            <div class="tooltip-wrapper" v-if="checkShowFbIcon(item)" @mouseenter="showOnHover(index)"
                                @mouseleave="hideOnHover" @click="toggleOnClick(index)" :ref="'tooltipWrapper' + index">
                                <img class="fb" alt="" src="/themes/web/assets/images/icon/has_fb.svg" />
                                <div v-if="visibleIndex == index" class="tooltip">
                                    Thoughtful teacher feedback <br />
                                    to support your growth
                                </div>
                            </div>
                            <img style="cursor: pointer; width: 90px" @click="openContentActivity(item)"
                                src="/themes/web/assets/images/icon/asm/btn-play.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { getAsmTestDueDate, CONTENTSTATUS, BUTTONS_FILTER, TYPE_CONTENT, StatusTodoListPriority } from "../../models/assignment";
import { getAllCourse } from "../../models/dashboard";
import { } from '../../utils/utils'
import { isMobileDevice } from "@/firebase";

export default {
    name: "Todolist",
    title: 'Todolist',

    components: {},

    data() {
        return {
            BUTTONS_FILTER,
            TYPE_CONTENT,
            CONTENTSTATUS,
            courses: [],
            rawCourses: [],
            status: CONTENTSTATUS.UNKNOW,
            course_id_filter: 0,
            rawAssignmnets: [],
            rawListAll: [],
            listAll: [],
            assignments: [],
            tests: [],
            activeButtonIndex: 3,
            keySearch: "",
            class_id_filter: 0,
            filteredCoursesAsm: null,
            filteredCoursesTest: null,
            filteredCoursesAll: null,
            visibleIndex: null,
            iconMap: {
                [CONTENTSTATUS.ON_GOING]: "/themes/web/assets/images/icon/asm/new.svg",
                [CONTENTSTATUS.INPROGRESS]: "/themes/web/assets/images/icon/asm/inprogress.svg",
                [CONTENTSTATUS.NEED_RESUBMIT]: "/themes/web/assets/images/icon/asm/return.svg",
                [CONTENTSTATUS.OVERDUE]: "/themes/web/assets/images/icon/asm/overdue.svg"
            },
            hideTimer: null,
        }
    },

    mounted() {
        document.addEventListener("click", this.handleDocumentClick);
        if (this.$store.getters.isShowMenu) {
            $('#assignment .right').css({ 'left': '130px' });
            $('#subject >.right').css({ 'left': '130px' });
        } else {
            $('#assignment .right').css({ 'left': '50px' });
            $('#subject >.right').css({ 'left': '50px' });
        }
        document.addEventListener("click", this.handleClickOutside);
    },

    beforeDestroy() {
        document.removeEventListener("click", this.handleDocumentClick);
        document.removeEventListener("click", this.handleClickOutside);
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },

    watch: {

    },

    created() {
        this.fetch()
        this.$store.commit('setMenuActive', 'todolist')
    },

    methods: {
        handleClickOutside(e) {
            const el = this.$refs['tooltipWrapper' + this.visibleIndex];
            const node = Array.isArray(el) ? el[0] : el;
            if (node && !node.contains(e.target)) {
                this.visibleIndex = null;
                this.clearAutoHide()
            }
        },
        showOnHover(i) {
            if (!isMobileDevice()) this.visibleIndex = i
        },
        hideOnHover() {
            if (!isMobileDevice()) this.visibleIndex = null
        },
        toggleOnClick(i) {
            if (isMobileDevice()) {
                this.visibleIndex = (this.visibleIndex === i) ? null : i
                if (this.visibleIndex !== null) {
                    this.startAutoHide()
                } else {
                    this.clearAutoHide()
                }
            }
        },
        startAutoHide() {
            this.clearAutoHide()
            this.hideTimer = setTimeout(() => {
                this.visibleIndex = null
            }, 10000)
        },
        clearAutoHide() {
            if (this.hideTimer) {
                clearTimeout(this.hideTimer)
                this.hideTimer = null
            }
        },
        statusConfig(item) {
            const map = {
                [this.CONTENTSTATUS.ON_GOING]: { class: 'new', text: 'To do' },
                [this.CONTENTSTATUS.INPROGRESS]: { class: 'inprogress', text: 'In Progress' },
                [this.CONTENTSTATUS.NEED_RESUBMIT]: { class: 'return', text: 'Allow retry' },
                [this.CONTENTSTATUS.OVERDUE]: { class: 'overdue', text: 'Overdue' }
            }
            return map[item.status] || null
        },
        checkShowFbIcon(item) {
            return (item.type_code == TYPE_CONTENT.TEST_LESSON || item.type_code == TYPE_CONTENT.TEST_MODULE || item.type_code == TYPE_CONTENT.TEST_SEMESTER || item.type_code == TYPE_CONTENT.ASM) && (item.status == CONTENTSTATUS.NEED_RESUBMIT) && item.has_feedback
        },
        changeCourse(course) {
            this.course_id_filter = course.course_id
            this.assignments = this.rawAssignmnets.slice();
            this.class_id_filter = course.class_id
            this.filterAssigmnets({ course_id: this.course_id_filter, buttonFilter: this.activeButtonIndex, searchText: this.keySearch, class_id: this.class_id_filter })
        },

        async fetch() {
            await this.getAllCourse(0)
            await this.GetAsmTestDueDate()
        },

        openContentActivity(item) {
            if (item.lock == 1) {
                return
            }
            if (item.type_code == TYPE_CONTENT.ASM || item.type_code == TYPE_CONTENT.TEST_LESSON) {
                this.$store.commit("setCurrentLessonPackage", {
                    type: 2,
                    status: item.status,
                    course_id: item.course_id,
                    module_id: item.module_id,
                    lesson_id: item.lesson_id,
                    class_id: item.class_id,
                    from_lsp: false,
                });
                this.$router.push({ path: '/lesson/' + item.class_id + '/' + item.course_id + '-' + item.module_id + '-' + item.lesson_id + '-' + item.lesson_package_id + '-' + item.course_item_id + '-' + 0 })
            } else if (item.type_code == TYPE_CONTENT.TEST_MODULE) {
                this.$store.commit("setCurrentLessonPackage", {
                    type: 3,
                    status: item.status,
                    from_lsp: false,
                });

                this.$router.push({
                    name: 'test_detail',
                    query: {
                        test: JSON.stringify(item),
                        type: 'end_of_module',
                        class_id: item.class_id,
                        course_id: item.course_id,
                        module_id: item.module_id
                    }
                });
            } else if (item.type_code == TYPE_CONTENT.TEST_SEMESTER) {
                this.$store.commit("setCurrentLessonPackage", {
                    type: 3,
                    status: item.status,
                    from_lsp: false,
                });
                this.$router.push({
                    name: 'test_detail',
                    query: {
                        test: JSON.stringify(item),
                        type: 'end_of_semester',
                        class_id: item.class_id,
                        course_id: item.course_id,
                        module_id: item.course_item_id
                    }
                });
            }
        },

        searchAssignments() {
            this.filterAssigmnets({ course_id: this.course_id_filter, buttonFilter: this.activeButtonIndex, searchText: this.keySearch, class_id: this.class_id_filter })
        },

        changeButtonFilter(fillter) {
            this.activeButtonIndex = fillter;
            this.filterAssigmnets({ course_id: this.course_id_filter, buttonFilter: this.activeButtonIndex, searchText: this.keySearch, class_id: this.class_id_filter })
            // if(!this.courses.some(course => course.course_id === this.course)){
            //     this.course_id_filter = 0;
            //     this.class_id_filter = 0
            // }
        },

        clearFilter() {
            this.course_id_filter = 0;
            this.class_id_filter = 0;
            this.filterAssigmnets({ course_id: this.course_id_filter, buttonFilter: this.activeButtonIndex, searchText: this.keySearch, class_id: this.class_id_filter })
        },

        async getAllCourse(program_id) {
            this.$store.commit("setLoading", true);
            const params = {
                program_id: program_id
            };
            await axios.all([
                getAllCourse(params),
            ]).then(axios.spread((report_response) => {
                if (report_response.data.code != 0) {
                    return;
                }

                let filterCourse = report_response.data.results?.filter((item) => item.is_started)

                this.rawCourses = filterCourse
                this.courses = filterCourse

                if (this.courses.length) {
                    this.courses.sort((a, b) => {
                        const nameA = a.course_name.toLowerCase();
                        const nameB = b.course_name.toLowerCase();

                        return nameA.localeCompare(nameB);
                    });
                }

                this.$store.commit("setLoading", false);
            }));
        },

        async GetAsmTestDueDate() {
            this.$store.commit("setLoading", true);
            await axios.all([
                getAsmTestDueDate(),
            ]).then(axios.spread((response) => {
                if (response.data.code != 0) {
                    return;
                }


                // this.listAll = response.data.results
                this.listAll = response.data.results.filter(e =>
                    this.rawCourses.some(course => course.class_id === e.class_id)
                );
                this.rawListAll = this.listAll
                this.listAll = this.rawListAll.slice();
                this.filterAssigmnets({ buttonFilter: this.activeButtonIndex, searchText: this.keySearch })

                const courseIdsInAll = new Set(this.listAll.map(e => e.course_id));
                const courseIdsInAsms = new Set(this.listAll.filter(e => e.type_code === "assignment").map(e => e.course_id));
                const courseIdsInTests = new Set(this.listAll.filter(e => (e.type_code === "end_of_semester" || e.type_code === "end_of_module" || e.type_code === "end_of_leson")).map(e => e.course_id));

                this.filteredCoursesAll = this.rawCourses.filter(c => courseIdsInAll.has(c.course_id));
                this.filteredCoursesAsm = this.rawCourses.filter(c => courseIdsInAsms.has(c.course_id));
                this.filteredCoursesTest = this.rawCourses.filter(c => courseIdsInTests.has(c.course_id));



                // this.courses = this.filteredCoursesAll
                this.$store.commit("setLoading", false);
            }));
        },

        filterAssigmnets({ course_id, buttonFilter, searchText, class_id }) {
            // if (buttonFilter == BUTTONS_FILTER.ALL) {
            //    this.courses = this.filteredCoursesAll
            // } else if (buttonFilter == BUTTONS_FILTER.ASSIGNMENT) {
            //    this.courses = this.filteredCoursesAsm
            // } else if (buttonFilter == BUTTONS_FILTER.TEST) {
            //    this.courses = this.filteredCoursesTest
            // }

            this.rawListAll.sort((a, b) => {
                const dateA = new Date(a.end_time);
                const dateB = new Date(b.end_time);
                const dateOnlyA = new Date(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
                const dateOnlyB = new Date(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());
                if (dateOnlyA - dateOnlyB !== 0) {
                    return dateOnlyA - dateOnlyB;
                }
                return StatusTodoListPriority[a.status] - StatusTodoListPriority[b.status];
            });

            this.listAll = this.rawListAll.filter(function (e) {
                var condition_course = true;
                var condition_searchText = true
                var condition_class = true
                var condition_buttonFilter = true;
                if (course_id && course_id > 0) {
                    condition_course = e.course_id == course_id;
                }

                if (class_id && class_id > 0) {
                    condition_class = e.class_id == class_id;
                }

                if (buttonFilter) {
                    switch (buttonFilter) {
                        case BUTTONS_FILTER.ALL:
                            condition_buttonFilter = true;
                            break;
                        case BUTTONS_FILTER.ASSIGNMENT:
                            condition_buttonFilter = e.type_code == TYPE_CONTENT.ASM;
                            break;
                        case BUTTONS_FILTER.TEST:
                            condition_buttonFilter = e.type_code == TYPE_CONTENT.TEST_LESSON || e.type_code == TYPE_CONTENT.TEST_MODULE || e.type_code == TYPE_CONTENT.TEST_SEMESTER;
                            break;
                    }
                }

                if (searchText) {
                    const normalizeText = (text) => text
                        .toLowerCase()
                        .replace(/\s*-\s*/g, ' ') // Xóa dấu gạch ngang và khoảng trắng dư thừa
                        .replace(/\s+/g, '');     // Xóa khoảng trắng dư thừa hoàn toàn

                    condition_searchText =
                        (e.type_code == TYPE_CONTENT.ASM && (normalizeText(e.path)?.toLowerCase() ?? '').includes(normalizeText(searchText).toLowerCase()) || (e.name_asm?.toLowerCase() ?? '').includes(searchText.toLowerCase())) ||
                        (e.type_code == TYPE_CONTENT.TEST_LESSON && (e.path?.toLowerCase() ?? '').includes(searchText.toLowerCase()) || (e.name_test_lesson?.toLowerCase() ?? '').includes(searchText.toLowerCase())) ||
                        (e.type_code == TYPE_CONTENT.TEST_MODULE && ((e.name_test_module?.toLowerCase() ?? '').includes(searchText.toLowerCase()))) ||
                        (e.type_code == TYPE_CONTENT.TEST_SEMESTER && ((e.name_test_semester?.toLowerCase() ?? '').includes(searchText.toLowerCase())))
                }
                return condition_class && condition_course && condition_searchText && condition_buttonFilter;
            })
        },
    }
}


</script>

<style scoped>
.no-filter {
    width: 100%;
    padding: 50px;
    color: var(--Pumpkin-Light, #FC7A1B);
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    border-radius: 24px;
    border: 2px solid var(--Pumpkin-Very-Light, #FFE9DA);
    background: var(--Creme-Light, #FFF);
}

.no-data {
    color: var(--Liquorice-Light, #777);
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    padding: 50px;
    height: calc(100% - 160px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.img-notstarted {
    opacity: 0.5;
    /* Làm mờ ảnh */
    -webkit-filter: grayscale(100%);
    /* Trình duyệt webkit (chrome, safari, ...)*/
    filter: grayscale(100%);
}

.item-asm.notstarted {
    background: var(--Cloud-Light, #DDD);
}

.item-asm.overdue {
    background: #FFDADE;
}

.p-status {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.6px;
    border-radius: 24px;
    background: var(--Jelly-Very-Light, #EAD4FF);
    padding: 8px;
    height: fit-content;
}

.p-status.new {
    background: var(--Jelly-Very-Light, #FFE9DA);
    color: var(--Jelly-Light, #FC7A1B);
}

.p-status.inprogress {
    background: var(--Jelly-Very-Light, #E9FFD9);
    color: var(--Jelly-Light, #58CC02);
}

.p-status.submitted {
    background: var(--Jelly-Very-Light, #EAD4FF);
    color: var(--Jelly-Light, #A560EB);
}

.p-status.notstarted {
    background: var(--Cloud-Dark, #CFCFCF);
    color: var(--Liquorice-Light, #777);
}

.p-status.graded {
    background: var(--Jelly-Very-Light, #EAD4FF);
    color: var(--Jelly-Light, #A560EB);
}

.p-status.return {
    background: var(--Jelly-Very-Light, #FFE9DA);
    color: var(--Jelly-Light, #FC7A1B);
}

.p-status.overdue {
    background: var(--Jelly-Very-Light, #FF3D54);
    color: var(--Jelly-Light, #FFF);
}

.item-asm .title {
    color: #000;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.32px;
    margin-bottom: 10px;
}

.date {
    color: var(--Liquorice-Light, #777);
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.24px;
}

.date.overdue {
    font-family: Montserrat;
    font-weight: 700;
    color: #FF3D54;
}

.dot-1 {
    width: 8px;
    height: 8px;
    background: #CFCFCF;
    border-radius: 50%;
}

.info>p {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.24px;
}

.info {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
}

.type-asm {
    color: var(--Rasberry-Light, #A560EB);
}

.type-test {
    color: var(--Rasberry-Light, #FC7A1B);
}

.path {
    font-weight: 300 !important;
    color: var(--Liquorice-Light, #777);
}

.list-asm {
    height: calc(100% - 160px);
    overflow-y: auto;
    overflow-x: hidden;
}

.list-asm .item-asm {
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CFCFCF;
}

.index {
    color: var(--Jelly-Light, #A560EB);
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.8px;
    margin-right: 10px;
}

.index>span {
    color: var(--Pumpkin-Light, #FC7A1B);
}

.content {
    border-radius: 24px;
    border: 2px solid var(--Jelly-Very-Light, #EAD4FF);
    background: var(--Creme-Light, #FFF);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
    overflow: hidden;
}

.content>.header {
    border-radius: 24px 24px 0px 0px;
    background: var(--Gradient-2, radial-gradient(109.13% 100% at 50% 100%, #CC97EF 0%, #BA53EA 100%));
}

.content>.header>p {
    padding: 16px 24px;
    color: #FFF;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.32px;
}

.clear {
    color: var(--Cloud-Dark, #CFCFCF);
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.24px;
    justify-self: flex-end;
    margin-top: 20px;
    cursor: pointer;
}

.list-choice {
    color: var(--Liquorice-Dark, #4C4C4C);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.24px;
    border-radius: 4px;
    border: 1px solid var(--Pumpkin-Very-Light, #FFE9DA);
    box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.15);
    width: 333px;
}

.list-choice .item-choice>p {
    text-overflow: ellipsis;
    overflow: hidden;
    text-wrap: nowrap;
}

.list-choice .item-choice.active {
    background-color: #FFE9DA;
}

.list-choice .item-choice {
    /* color: var(--Pumpkin-Light, #FC7A1B); */
    color: var(--Liquorice-Dark, #4C4C4C);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.24px;


    height: 40px;
    padding: 16px;
    background: var(--Creme-Light, #FFF);
    cursor: pointer;
    display: flex;
    align-items: center;
    /* border-radius: 4px; */
    /* border: 1px solid var(--Pumpkin-Very-Light, #FFE9DA); */
}

.list-choice .item-choice:hover {
    background: var(--Pumpkin-Very-Light, #FFE9DA);
}

.filter .label {
    color: var(--squid-black, #1D1D1F);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.24px;
}

.input-filter.course {
    background: #fff;
}

.input-filter.disable {
    background: #DDDDDD;
}

.input-filter>p {
    color: var(--Liquorice-Light, #777);
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.32px;
}

.input-filter>.p-active {
    color: var(--Liquorice-Dark, #4C4C4C);
    font-weight: 700;
    text-overflow: ellipsis;
    overflow: hidden;
    text-wrap: nowrap;
}

.input-filter {
    border-radius: 8px;
    border: 1px solid var(--Cloud-Dark, #CFCFCF);
    background: #FFF;
    box-shadow: 2px 2px 0px 0px #CFCFCF;
    padding: 8px 16px;
    display: flex;
    width: 200px;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    cursor: pointer;
}

.input-filter.active {
    border: 1px solid var(--Pumpkin-Light, #FC7A1B);
    background: var(--Pumpkin-Very-Light, #FFE9DA);
    box-shadow: 2px 2px 0px 0px #FC7A1B;
}

.block-filter {
    gap: 16px;
    display: flex;
    margin-top: 8px;
    border-radius: 24px;
    border: 1px dashed var(--Cloud-Dark, #CFCFCF);
    background: var(--Creme-Dark, #F8FAFC);
    padding: 16px 16px 16px 16px;
    justify-content: space-between;
    margin-bottom: 8px;
}

#assignment .right {
    background: #FFFFFF;
    height: 100%;
    /* width: calc(100% - 56px); */
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.25);
    border-radius: 24px 0px 0px 24px;
    padding: 24px;
    overflow: auto;
    flex: 1;
    position: fixed;
    left: 50px;
    right: 0;
}

.list-btn {
    display: flex;
    gap: 16px;
    width: 45%;

    .btn-wraper {
        width: 33%;
        max-width: 167px;
    }
}

.list-btn>div {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.btn {
    text-align: center;
    width: 100%;
    /* width: 167px; */
    padding: 16px 0;
    border-radius: 24px;
    border: 2px solid var(--Creme-Light, #FFF);
    background: var(--Creme-Dark, #F8FAFC);

    color: var(--squid-black, #1D1D1F);
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.32px;
    cursor: pointer;
}

.btn.active {
    border-radius: 24px;
    border: 2px solid var(--Pumpkin-Light, #FC7A1B);
    background: var(--Linear-Orange, linear-gradient(180deg, #FF9E44 41.67%, #FF891C 62.5%));
    box-shadow: 0px 0px 16px 0px #FC7A1B;

    color: #FFF;
}

.dot {
    fill: var(--Pumpkin-Light, #FC7A1B);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #FC7A1B;
    margin-bottom: 3px;
    position: absolute;
    top: 13px;
}

.right>.header>h4 {
    color: #000;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 0.64px;
    /* margin-right: 90px; */
}

.right>.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 18px;
    border-bottom: 1px solid #A9A9A9;
    gap: 15px;
    flex-wrap: wrap;
}

.search .form {
    display: flex;
    background: #fff;
    border-radius: 30px;
    height: 40px;
    padding: 8px 8px 8px 16px;
    align-items: center;
    gap: 24px;
    align-self: stretch;

    border-radius: 48px;
    border: 1px solid #191715;
    background: #FFF;
    box-shadow: 4px 4px 0px 0px #191715;
}

.search .icon-search {
    width: 16px;
    /* margin:0 16px; */
}

.search .form-search {
    outline: none;
    border: none;
    font-size: 12px;
    margin-right: 8px;
    width: 150px;
}

input[type="radio"] {
    transform: scale(1.5);
}

label p {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-align: left;
    color: #1D1D1F;
}

.control-asm {
    cursor: pointer;
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 20px;
}

.course-programs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.course-programs>p {
    color: var(--Creme-Light, #FFF);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.24px;
}

.fb {
    margin-left: 12px;
}

.tooltip-wrapper {
    position: relative;
    display: inline-block;
}

.tooltip {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    background: #A9A9A9;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 10;
}

.course-programs .program-card {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    border-radius: 24px;
    border: 2px solid var(--cloud-light, #DDD);
    background: var(--creme-light, #FFF);
    color: var(--squid-black, #191715);
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.24px;
    cursor: pointer;
    box-sizing: border-box;
}

.course-programs .program-card p {
    max-width: 320px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.course-programs .program-card.active {
    color: #fff;
    border: 2px solid var(--blueberry-dark, #2376A8);
    background: var(--blueberry-light, #02A6E7);
    box-sizing: border-box;
}

.course-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.4px;
    color: var(--Liquorice-Dark, #4C4C4C);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 80%;
}

.lock {
    opacity: 0.25;
    background: var(--Jelly-Very-Light, #ead4ff);
}
</style>
